import {parseQueryString} from '../../../../libs/shared/helpers/src/browser/urlHelpers';
import {reportToBugsnag} from '../../../../srcCommon/services/bugsnag/bugsnag';
import {parseInboxesUrl} from '../../../models/url/inboxesUrlModel';
import {AppState} from '../../appState';
import {PanelRoute, PanelRouteProps} from '../panelRoutes';
import {InboxesParameters} from './parameters/inboxesParameters';
import {getInboxesParametersParser} from './parameters/inboxesParametersSelectors';

/*
 * Types.
 */

export type InboxesPanelRoute = PanelRoute<AppState, InboxesParameters | undefined>;

/*
 * Selectors.
 */

function getParameters(state: AppState, props: PanelRouteProps): InboxesParameters | undefined {
  try {
    const inboxesUrl = parseInboxesUrl({
      ...props.params,
      ...parseQueryString(props.search),
    });
    const parseInboxesParameters = getInboxesParametersParser(state);
    return parseInboxesParameters(inboxesUrl);
  } catch (error) {
    reportToBugsnag(error);
    return undefined;
  }
}

/*
 * Routes.
 */

export function buildInboxesPanelRoutes(): ReadonlyArray<InboxesPanelRoute> {
  const selectedTokensSuffix = '/:selectedTokens?';
  const searchSuffix = `/:fromSelectedTokens/search/:searchLocation(local|global|workspace)/:searchQuery${selectedTokensSuffix}`;

  const basePaths = [
    '/global/:globalFolder/:filters',
    '/teammates/folders/:teammateInboxId/:filters',
    '/teammates/views/:teammateViewId/:filters',
    '/teammates/views/:teammateViewId',
    '/teammates/lenses/:teammateLensId/:filters',
    '/teammates/lenses/:teammateLensId',
    '/teammates/:teammateId/:folder(sent|drafts|outbox)',
    '/teammates/:teammateId/:folder/:filters',
    '/teammates/:teammateId/:folder',
    '/teams/folders/:inboxId/:filters',
    '/teams/views/:viewId/:filters',
    '/teams/lenses/:teamLensId/:filters',
    '/teams/:teamId/:folder/:filters',
  ];

  const paths = [
    // With search suffix.
    ...basePaths.map((basePath) => `${basePath}${searchSuffix}`),
    // Without search suffix.
    ...basePaths.map((basePath) => `${basePath}${selectedTokensSuffix}`),
  ];

  return [
    ...paths.map((path) => ({
      path,
      getParameters,
    })),
    {
      path: '/',
      getParameters: () => undefined,
    },
  ];
}
